import meowUrl from "../audio/meow.mp3";

let audio;

export function playMeow() {
    if (!audio) {
        audio = new Audio(meowUrl);
        audio.volume = 0.6;
    }

    if (!audio.paused) {
        return;
    }

    audio.currentTime = 0;
    audio.play().catch(() => {
        // An unavailable sound must not interrupt the app.
    });
}
